import { ActionButton } from 'elements/eventView/atomic/ActionButton';
import { useIsWide } from 'libs/utils/logic/ui/responsiveLogic';
import { CustomMapPage, CustomMapPageProps } from 'pages/custom/shared/CustomMapPage';
import { useRef, useState } from 'react';
import { MapRef } from 'react-map-gl';
import styled from 'styled-components/macro';

export const FjellsportMapWrapper = (props: CustomMapPageProps): JSX.Element => {
    const [zoom, setZoom] = useState(0);
    const ref = useRef<MapRef>(null);
    const isWide = useIsWide();

    const getPitch = () => {
        const maxPan = 40;
        const minPan = 10;
        const zoomMin = 14;
        const zoomMax = 16;

        if (zoom < zoomMin) {
            return maxPan;
        }
        if (zoom > zoomMax) {
            return minPan;
        }

        const a = (maxPan - minPan) / (zoomMin - zoomMax);
        const b = minPan - a * zoomMax;

        return a * zoom + b;
    };

    function goToFestivalArea() {
        const coordinates: [[number, number], [number, number]] = isWide
            ? [
                  [6.9670100882087524, 61.2894109632918],
                  [6.969005988452267, 61.288788833864146]
              ]
            : [
                  [6.9673757493217465, 61.289415145632574],
                  [6.968967243876364, 61.288624677199806]
              ];

        ref?.current?.fitBounds(coordinates, { animate: true, duration: 3000 });
    }

    function gotToHotel() {
        const coordinates: [[number, number], [number, number]] = isWide
            ? [
                  [7.095056, 61.231305],
                  [7.102111, 61.228906]
              ]
            : [
                  [7.096808, 61.230913],
                  [7.100779, 61.228831]
              ];

        ref?.current?.fitBounds(coordinates, { animate: true, duration: 3000 });
    }

    return (
        <>
            <S_InitialSnow className="initial-snow">
                <div className="snow">&#10052;</div>
                <div className="snow">&#10052;</div>
                <div className="snow">&#10052;</div>
                <div className="snow">&#10052;</div>
                <div className="snow">&#10052;</div>
                <div className="snow">&#10052;</div>
                <div className="snow">&#10052;</div>
                <div className="snow">&#10052;</div>
                <div className="snow">&#10052;</div>
                <div className="snow">&#10052;</div>
                <div className="snow">&#10052;</div>
                <div className="snow">&#10052;</div>
                <div className="snow">&#10052;</div>
                <div className="snow">&#10052;</div>
                <div className="snow">&#10052;</div>
                <div className="snow">&#10052;</div>
                <div className="snow">&#10052;</div>
                <div className="snow">&#10052;</div>
                <div className="snow">&#10052;</div>
                <div className="snow">&#10052;</div>
                <div className="snow">&#10052;</div>
                <div className="snow">&#10052;</div>
                <div className="snow">&#10052;</div>
                <div className="snow">&#10052;</div>
                <div className="snow">&#10052;</div>
                <div className="snow">&#10052;</div>
                <div className="snow">&#10052;</div>
                <div className="snow">&#10052;</div>
                <div className="snow">&#10052;</div>
                <div className="snow">&#10052;</div>
                <div className="snow">&#10052;</div>
                <div className="snow">&#10052;</div>
                <div className="snow">&#10052;</div>
                <div className="snow">&#10052;</div>
                <div className="snow">&#10052;</div>
                <div className="snow">&#10052;</div>
                <div className="snow">&#10052;</div>
                <div className="snow">&#10052;</div>
                <div className="snow">&#10052;</div>
                <div className="snow">&#10052;</div>
                <div className="snow">&#10052;</div>
                <div className="snow">&#10052;</div>
                <div className="snow">&#10052;</div>
                <div className="snow">&#10052;</div>
                <div className="snow">&#10052;</div>
                <div className="snow">&#10052;</div>
                <div className="snow">&#10052;</div>
                <div className="snow">&#10052;</div>
                <div className="snow">&#10052;</div>
                <div className="snow">&#10052;</div>
            </S_InitialSnow>
            <CustomMapPage
                {...props}
                mapProps={{
                    ...props.mapProps,
                    pitch: getPitch()
                }}
                onMapLoaded={(mapRef) => {
                    const map = mapRef.getMap();

                    ref.current = mapRef;

                    setZoom(map.getZoom());

                    map.on('zoom', (e) => {
                        const z = e.target.getZoom();
                        setZoom(z);
                    });

                    const source = map.getSource('mapbox-dem');
                    if (!source) {
                        map.addSource('mapbox-dem', {
                            type: 'raster-dem',
                            url: 'mapbox://mapbox.mapbox-terrain-dem-v1',
                            tileSize: 512,
                            maxzoom: 14
                        });
                    }

                    props.onMapLoaded?.(mapRef);
                }}
                customClickableMarkerIds={
                    new Set([
                        '0.5687569977680502',
                        '0.720239340996609',
                        '0.13978667543896317',
                        '0.03430703623433473'
                    ])
                }
                onMarkerSelected={(markerId) => {
                    if (markerId === '0.5687569977680502' || markerId === '0.720239340996609') {
                        gotToHotel();
                        return true;
                    }
                    if (markerId === '0.13978667543896317' || markerId === '0.03430703623433473') {
                        goToFestivalArea();
                        return true;
                    }
                    return props?.onMarkerSelected?.(markerId);
                }}
                topOverflow={
                    <S_Buttons>
                        <S_ActionButton
                            icon={{ iconSet: 'fal', iconName: 'location-crosshairs' }}
                            text={'Festival area'}
                            highlighted={false}
                            onClick={goToFestivalArea}
                        />
                        <S_ActionButton
                            icon={{ iconSet: 'fal', iconName: 'location-crosshairs' }}
                            text={'Quality Hotel'}
                            highlighted={false}
                            onClick={gotToHotel}
                        />
                    </S_Buttons>
                }
                topOverflowPosition="right"
            />
        </>
    );
};

const S_Buttons = styled.div`
    display: flex;
    flex-direction: column;
    gap: 10px;
    pointer-events: all;
`;

const S_ActionButton = styled(ActionButton)`
    width: 100%;
    justify-content: start;
`;

const S_InitialSnow = styled.div`
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    overflow: hidden;
    z-index: 1;
    pointer-events: none;
    @keyframes snowfall {
        0% {
            transform: translate3d(var(--left-ini), 0, 0);
        }

        100% {
            transform: translate3d(var(--left-end), 110vh, 0);
        }
    }
    & > * {
        font-size: 30px;
        color: white;
        position: absolute;
        top: -5vh;
    }
    > :nth-child(2n) {
        filter: blur(1px);
        font-size: 20px;
    }
    > :nth-child(6n) {
        filter: blur(2px);
        font-size: 10px;
    }
    > :nth-child(10n) {
        filter: blur(5px);
        font-size: 5px;
    }
    > :nth-child(1) {
        --size: 0.8vw;
        --left-ini: 0vw;
        --left-end: -1vw;
        left: 70vw;
        animation: snowfall 15s linear infinite;
        animation-delay: -1s;
    }
    > :nth-child(2) {
        --size: 0.2vw;
        --left-ini: -7vw;
        --left-end: 10vw;
        left: 65vw;
        animation: snowfall 22s linear infinite;
        animation-delay: -8s;
    }

    > :nth-child(3) {
        --size: 1vw;
        --left-ini: 6vw;
        --left-end: 6vw;
        left: 1vw;
        animation: snowfall 16s linear infinite;
        animation-delay: -7s;
    }

    > :nth-child(4) {
        --size: 0.2vw;
        --left-ini: -3vw;
        --left-end: 9vw;
        left: 88vw;
        animation: snowfall 19s linear infinite;
        animation-delay: -5s;
    }

    > :nth-child(5) {
        --size: 0.4vw;
        --left-ini: -2vw;
        --left-end: -9vw;
        left: 74vw;
        animation: snowfall 13s linear infinite;
        animation-delay: -4s;
    }

    > :nth-child(6) {
        --size: 0.2vw;
        --left-ini: 5vw;
        --left-end: 1vw;
        left: 35vw;
        animation: snowfall 13s linear infinite;
        animation-delay: -7s;
    }

    > :nth-child(7) {
        --size: 0.4vw;
        --left-ini: -2vw;
        --left-end: -1vw;
        left: 27vw;
        animation: snowfall 15s linear infinite;
        animation-delay: -8s;
    }

    > :nth-child(8) {
        --size: 1vw;
        --left-ini: -9vw;
        --left-end: -2vw;
        left: 69vw;
        animation: snowfall 12s linear infinite;
        animation-delay: -8s;
    }

    > :nth-child(9) {
        --size: 0.2vw;
        --left-ini: -1vw;
        --left-end: -5vw;
        left: 84vw;
        animation: snowfall 19s linear infinite;
        animation-delay: -6s;
    }

    > :nth-child(10) {
        --size: 0.2vw;
        --left-ini: 7vw;
        --left-end: -9vw;
        left: 82vw;
        animation: snowfall 22s linear infinite;
        animation-delay: -3s;
    }

    > :nth-child(11) {
        --size: 0.6vw;
        --left-ini: -2vw;
        --left-end: -1vw;
        left: 48vw;
        animation: snowfall 22s linear infinite;
        animation-delay: -1s;
    }

    > :nth-child(12) {
        --size: 0.2vw;
        --left-ini: 5vw;
        --left-end: 6vw;
        left: 39vw;
        animation: snowfall 31s linear infinite;
        animation-delay: -8s;
    }

    > :nth-child(13) {
        --size: 0.2vw;
        --left-ini: 6vw;
        --left-end: 5vw;
        left: 3vw;
        animation: snowfall 16s linear infinite;
        animation-delay: -8s;
    }

    > :nth-child(14) {
        --size: 0.8vw;
        --left-ini: -5vw;
        --left-end: -2vw;
        left: 49vw;
        animation: snowfall 17s linear infinite;
        animation-delay: -8s;
    }

    > :nth-child(15) {
        --size: 0.6vw;
        --left-ini: 10vw;
        --left-end: 4vw;
        left: 77vw;
        animation: snowfall 17s linear infinite;
        animation-delay: -4s;
    }

    > :nth-child(16) {
        --size: 0.8vw;
        --left-ini: -3vw;
        --left-end: 1vw;
        left: 86vw;
        animation: snowfall 24s linear infinite;
        animation-delay: -8s;
    }

    > :nth-child(17) {
        --size: 1vw;
        --left-ini: 6vw;
        --left-end: -7vw;
        left: 18vw;
        animation: snowfall 19s linear infinite;
        animation-delay: -6s;
    }

    > :nth-child(18) {
        --size: 1vw;
        --left-ini: -9vw;
        --left-end: 4vw;
        left: 64vw;
        animation: snowfall 23s linear infinite;
        animation-delay: -7s;
    }

    > :nth-child(19) {
        --size: 1vw;
        --left-ini: 2vw;
        --left-end: -7vw;
        left: 52vw;
        animation: snowfall 25s linear infinite;
        animation-delay: -9s;
    }

    > :nth-child(20) {
        --size: 0.4vw;
        --left-ini: 0vw;
        --left-end: 8vw;
        left: 5vw;
        animation: snowfall 18s linear infinite;
        animation-delay: -9s;
    }

    > :nth-child(21) {
        --size: 0.6vw;
        --left-ini: -9vw;
        --left-end: -2vw;
        left: 10vw;
        animation: snowfall 22s linear infinite;
        animation-delay: -3s;
    }

    > :nth-child(22) {
        --size: 0.8vw;
        --left-ini: -3vw;
        --left-end: -8vw;
        left: 54vw;
        animation: snowfall 21s linear infinite;
        animation-delay: -9s;
    }

    > :nth-child(23) {
        --size: 0.6vw;
        --left-ini: -7vw;
        --left-end: -8vw;
        left: 20vw;
        animation: snowfall 16s linear infinite;
        animation-delay: -3s;
    }

    > :nth-child(24) {
        --size: 0.4vw;
        --left-ini: 10vw;
        --left-end: -4vw;
        left: 68vw;
        animation: snowfall 20s linear infinite;
        animation-delay: -8s;
    }

    > :nth-child(25) {
        --size: 1vw;
        --left-ini: 3vw;
        --left-end: 5vw;
        left: 90vw;
        animation: snowfall 17s linear infinite;
        animation-delay: -9s;
    }

    > :nth-child(26) {
        --size: 1vw;
        --left-ini: -7vw;
        --left-end: 5vw;
        left: 71vw;
        animation: snowfall 23s linear infinite;
        animation-delay: -2s;
    }

    > :nth-child(27) {
        --size: 0.6vw;
        --left-ini: 9vw;
        --left-end: 4vw;
        left: 2vw;
        animation: snowfall 20s linear infinite;
        animation-delay: -5s;
    }

    > :nth-child(28) {
        --size: 1vw;
        --left-ini: -5vw;
        --left-end: 3vw;
        left: 23vw;
        animation: snowfall 22s linear infinite;
        animation-delay: -1s;
    }

    > :nth-child(29) {
        --size: 0.4vw;
        --left-ini: -2vw;
        --left-end: -1vw;
        left: 39vw;
        animation: snowfall 24s linear infinite;
        animation-delay: -9s;
    }

    > :nth-child(30) {
        --size: 0.6vw;
        --left-ini: -9vw;
        --left-end: -5vw;
        left: 76vw;
        animation: snowfall 20s linear infinite;
        animation-delay: -5s;
    }

    > :nth-child(31) {
        --size: 0.4vw;
        --left-ini: -5vw;
        --left-end: 3vw;
        left: 14vw;
        animation: snowfall 18s linear infinite;
        animation-delay: -5s;
    }

    > :nth-child(32) {
        --size: 0.2vw;
        --left-ini: 5vw;
        --left-end: -1vw;
        left: 86vw;
        animation: snowfall 20s linear infinite;
        animation-delay: -9s;
    }

    > :nth-child(33) {
        --size: 0.4vw;
        --left-ini: -3vw;
        --left-end: 10vw;
        left: 66vw;
        animation: snowfall 6s linear infinite;
        animation-delay: -6s;
    }

    > :nth-child(34) {
        --size: 1vw;
        --left-ini: -3vw;
        --left-end: 6vw;
        left: 75vw;
        animation: snowfall 24s linear infinite;
        animation-delay: -9s;
    }

    > :nth-child(35) {
        --size: 1vw;
        --left-ini: -6vw;
        --left-end: 7vw;
        left: 22vw;
        animation: snowfall 17s linear infinite;
        animation-delay: -5s;
    }

    > :nth-child(36) {
        --size: 1vw;
        --left-ini: 3vw;
        --left-end: 4vw;
        left: 10vw;
        animation: snowfall 21s linear infinite;
        animation-delay: -10s;
    }

    > :nth-child(37) {
        --size: 0.6vw;
        --left-ini: 2vw;
        --left-end: 10vw;
        left: 95vw;
        animation: snowfall 23s linear infinite;
        animation-delay: -6s;
    }

    > :nth-child(38) {
        --size: 0.8vw;
        --left-ini: 5vw;
        --left-end: 8vw;
        left: 34vw;
        animation: snowfall 19s linear infinite;
        animation-delay: -10s;
    }

    > :nth-child(39) {
        --size: 0.8vw;
        --left-ini: 4vw;
        --left-end: 0vw;
        left: 80vw;
        animation: snowfall 21s linear infinite;
        animation-delay: -2s;
    }

    > :nth-child(40) {
        --size: 0.8vw;
        --left-ini: 1vw;
        --left-end: -7vw;
        left: 45vw;
        animation: snowfall 21s linear infinite;
        animation-delay: -4s;
    }

    > :nth-child(41) {
        --size: 0.2vw;
        --left-ini: 9vw;
        --left-end: 10vw;
        left: 82vw;
        animation: snowfall 18s linear infinite;
        animation-delay: -2s;
    }

    > :nth-child(42) {
        --size: 1vw;
        --left-ini: 9vw;
        --left-end: -9vw;
        left: 22vw;
        animation: snowfall 20s linear infinite;
        animation-delay: -6s;
    }

    > :nth-child(43) {
        --size: 0.6vw;
        --left-ini: 5vw;
        --left-end: 8vw;
        left: 66vw;
        animation: snowfall 19s linear infinite;
        animation-delay: -1s;
    }

    > :nth-child(44) {
        --size: 0.6vw;
        --left-ini: -5vw;
        --left-end: -2vw;
        left: 75vw;
        animation: snowfall 19s linear infinite;
        animation-delay: -4s;
    }

    > :nth-child(45) {
        --size: 0.2vw;
        --left-ini: 0vw;
        --left-end: 3vw;
        left: 2vw;
        animation: snowfall 17s linear infinite;
        animation-delay: -5s;
    }

    > :nth-child(46) {
        --size: 0.2vw;
        --left-ini: 8vw;
        --left-end: -3vw;
        left: 94vw;
        animation: snowfall 18s linear infinite;
        animation-delay: -9s;
    }

    > :nth-child(47) {
        --size: 0.6vw;
        --left-ini: -6vw;
        --left-end: -9vw;
        left: 95vw;
        animation: snowfall 21s linear infinite;
        animation-delay: -4s;
    }

    > :nth-child(48) {
        --size: 0.2vw;
        --left-ini: -5vw;
        --left-end: 6vw;
        left: 34vw;
        animation: snowfall 20s linear infinite;
        animation-delay: -6s;
    }

    > :nth-child(49) {
        --size: 0.8vw;
        --left-ini: 4vw;
        --left-end: 8vw;
        left: 22vw;
        animation: snowfall 22s linear infinite;
        animation-delay: -10s;
    }

    > :nth-child(50) {
        --size: 0.2vw;
        --left-ini: -4vw;
        --left-end: 4vw;
        left: 100vw;
        animation: snowfall 24s linear infinite;
        animation-delay: -9s;
    }
`;
